// extracted by mini-css-extract-plugin
export default {"root__title":"style-module__root__title___s0GwI"};
    if(module.hot) {
      // 1729151124996
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  